/* eslint-disable no-unused-expressions */

const setElementTransition = ( element, properties, duration ) => {
  element.style.transitionProperty = properties;
  element.style.transitionDuration = `${duration}ms`;
  element.style.boxSizing = 'border-box';
};

const resetElementStyles = ( element, styles ) => {
  styles.forEach( style => element.style.removeProperty( style ) );
};

const setMultipleStyles = ( element, styles ) => {
  Object.keys( styles ).forEach( style => {
    element.style[style] = styles[style];
  } );
};

export const slideUp = ( target, duration = 250 ) => {
  setElementTransition( target, 'height, margin, padding', duration );
  target.style.height = `${target.offsetHeight}px`;
  target.offsetHeight; // NOSONAR

  setMultipleStyles( target, {
    overflow: 'hidden',
    height: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
  } );

  window.setTimeout( () => {
    target.style.display = 'none';
    resetElementStyles( target, [
      'height', 
      'padding-top', 
      'padding-bottom', 
      'margin-top', 
      'margin-bottom', 
      'overflow', 
      'transition-duration', 
      'transition-property'
    ] );
  }, duration );
};

export const slideDown = ( target, duration = 250 ) => {
  target.style.removeProperty( 'display' );
  let display = window.getComputedStyle( target ).display;

  if ( display === 'none' ) display = 'block';

  target.style.display = display;
  const height = target.offsetHeight;
  setElementTransition( target, 'height, margin, padding', duration );

  setMultipleStyles( target, {
    overflow: 'hidden',
    height: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
  } );

  target.offsetHeight; // NOSONAR
  target.style.height = `${height}px`;
  resetElementStyles( target, [
    'padding-top', 
    'padding-bottom', 
    'margin-top', 
    'margin-bottom'
  ] );
  window.setTimeout( () => {
    resetElementStyles( target, [
      'height', 
      'overflow', 
      'transition-duration', 
      'transition-property'
    ] );
  }, duration );
};

export const slideToggle = ( target, duration = 250 ) => {
  if ( window.getComputedStyle( target ).display === 'none' ) {
    return slideDown( target, duration );
  }
  return slideUp( target, duration );
};

export const addClass = ( element, className = 'active' ) => {
  element.classList.add( className );
};

export const removeClass = ( element, className = 'active' ) => {
  element.classList.remove( className );
};

export const toggleClass = ( element, className = 'active' ) => {
  element.classList.toggle( className );
};

export const shrinkAccordionItems = ( items ) => {
  items.forEach( item => {
    const id = item.dataset.itemId;
    const body = document.getElementById( id );
    removeClass( item );
    slideUp( body );
  } );
};

export const toggleFloatPanels = ( floatPanels, id ) => {
  floatPanels.forEach( panel => {
    if ( panel.dataset.id !== id ) {
      removeClass( panel );
    } else {
      addClass( panel );
    }
  } );
};

export const toggleAccordionItem = ( id ) => {
  const wrapper = document.querySelector( `[data-item-id="${id}"]` );
  const body = document.getElementById( id );
  slideToggle( body );
  toggleClass( wrapper );
};

export const getTallestElement = ( elements ) => {
  return Math.max(
    ...Array.from( elements ).map( element => {
      const parentStyle = element.parentElement.style;
      element.style.minHeight = 'auto';
      if ( parentStyle.display === 'none' ) {
        parentStyle.display = 'block';
        const height = element.offsetHeight;
        parentStyle.display = 'none';
        return height;
      }
      return element.offsetHeight;
    } )
  );
};


export const matchHeight = ( elements ) => {
  const tallest = getTallestElement( elements );
  elements.forEach( element => {
    element.style.minHeight = `${tallest}px`;
  } );
};
